import React from 'react'
import Footer from '../../../Components/Footer'
import Lpntable from './Components/Lpn-table'
import Header from '../../../Components/Header'
import { Helmet } from 'react-helmet'

const ShipmentList = () => {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
            <Helmet>
				    <title>Gate Out List</title>
			  </Helmet>
            <Header/>
            <Lpntable />
            {/* <Footer /> */}
        </div>
    )
}

export default ShipmentList